import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=0f4587e9&scoped=true&"
import script from "./ImageSelector.vue?vue&type=script&lang=babel&"
export * from "./ImageSelector.vue?vue&type=script&lang=babel&"
import style0 from "vue2-dropzone/dist/vue2Dropzone.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ImageSelector.vue?vue&type=style&index=1&id=0f4587e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4587e9",
  null
  
)

export default component.exports